module.exports = __webpack_public_path__ + "static/media/p_27_0.cb8c5a20.png";